export { default } from './UploadCompanyFile';
